// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
  },
};
var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
var boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

/************************** BUILD PRODUCT LIST **************************/
(function() {
  BoostPFS.inject(this);

  /* some code */
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    var itemInlineLifestyleblock = boostPFSTemplate.inlineLifestyleBlock;

        itemHtml = itemHtml.replace(/{{itemClassGridItemWidth}}/g, boostPFSConfig.custom.grid_item_width);
        itemHtml = itemHtml.replace(/{{itemAosProductPerRow}}/g, boostPFSConfig.custom.products_per_row);

    // Get Image size
    var imgSize = '450x650';
    switch (boostPFSConfig.custom.products_per_row) {
      case 5:
        imgSize = '350x550';
        break;
      case 4:
        imgSize = '450x650';
        break;
      case 3:
        imgSize = '450x650';
        break;
      case 2:
        imgSize = '850x1050';
        break;
      case 1:
        imgSize = '1400x1800';
        break;
    }

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : 1;
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : 100;
    var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], imgSize) : boostPFSConfig.general.no_image_url;
    var thumb = images.length > 0 ? images[0] : { src: boostPFSConfig.general.no_image_url, width: 500, height: 500 };
    var bgset = buildBgSet(thumb);
    var itemImagesHtml = '';
    var fixed_aspect_ratio = !(boostPFSConfig.custom.product_grid_image_size === 'natural') ? true : false;
    var product_grid_image_fill = boostPFSConfig.custom.product_grid_image_fill ? '' : 'grid__image-contain';
    if (fixed_aspect_ratio) {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '">' +
                          '<img class="lazyload ' + product_grid_image_fill + '" ' +
                            'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                            'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                            'data-aspectratio="' + aspectRatio + '" ' +
                            'data-sizes="auto" ' +
                            'alt="{{itemTitle}}">' +
                        '</div>';
    } else {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">' +
                          '<img ' +
                            'class="grid-view-item__image lazyload" ' +
                            'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                            'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                            'data-aspectratio="' + aspectRatio + '" ' +
                            'data-sizes="auto" ' +
                            'alt="{{itemTitle}}">' +
                          '<noscript>' +
                            '<img class="grid-product__image lazyloaded" src="' + Utils.getFeaturedImage(images, '400x') + '" alt={{itemTitle}}' +
                          '</noscript>' +
                        '</div>';
    }

    if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
      itemImagesHtml += '<div class="grid-product__secondary-image small--hide">' +
                          '<img class="lazyload" ' +
                            'data-src="' + Utils.optimizeImage(images[1]['src'], '{width}x') + '" ' +
                            'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                            'data-aspectratio="' + images[1]['width'] / images[1]['height'] + '" ' +
                            'data-sizes="auto" ' +
                            'alt="{{itemTitle}}">' +
                        '</div>';
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
if (onSale) {
  itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
  itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
  itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';

  if (priceVaries) {
    itemPriceHtml += '<span class="sale-price">' + boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '</span>';
  } else {
    itemPriceHtml += '<span class="sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
  }
} else {
  // Not on sale, show regular price
  if (priceVaries) {
    itemPriceHtml += '<span class="regular-price">' + boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '</span>';
  } else {
    itemPriceHtml += '<span class="regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
  }
}

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? '<div class="grid-product__tag-text">' + boostPFSConfig.label.sold_out + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add custom Label
    var customTag = false;
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = tag.split('pfs:label-')[1];
          tagLabel += preTagLabel;
          customTag = true;
        }
      }
    }

    var tagLabelHtml = customTag ? '<div class="grid-product__tag-text">' + tagLabel + '</div>' : '';
    itemHtml = itemHtml.replace(/{{tagLabelHtml}}/g, tagLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = '';
    if (onSale && !soldOut && tagLabel == '') {
      var savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      itemSaleLabelHtml = '<div class="grid-product__tag-text">' + boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice) + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var itemReviewsHtml = '';
      if (boostPFSConfig.custom.enable_product_reviews) {
        itemReviewsHtml = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    }

    // Add Swatch
    var itemSwatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    // Inline Lifestyle Blocks Logic
		if (boostPFSThemeConfig.inlineLifestyleBlocks && boostPFSThemeConfig.inlineLifestyleBlocks.length) {
			
			let currentBlockIndex = document.body.hasAttribute('data-current-inline-block') 
				? Number(document.body.getAttribute('data-current-inline-block')) + 1 
				: 1;
		
			let lifestyleData = boostPFSThemeConfig.inlineLifestyleBlocks[currentBlockIndex - 1];
			if (lifestyleData) {
				itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{eyebrow}}/g, lifestyleData.eyebrow || '');
				itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{title}}/g, lifestyleData.title || '');
				itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{text_alignment}}/g, lifestyleData.text_alignment || '');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{text_colour}}/g, lifestyleData.text_colour || '');			
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{description}}/g, lifestyleData.description || '');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{link_url}}/g, lifestyleData.link_url || '');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{link_text}}/g, lifestyleData.link_text || '');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{column_size}}/g, lifestyleData.column_size || '');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{opacity}}/g, lifestyleData.opacity || 1);
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{overlay_colour}}/g, lifestyleData.overlay_colour || '#000000');
        itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{repeat_block}}/g, lifestyleData.repeat_block || false);

        if (lifestyleData.eyebrow_size) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(
            /{{eyebrow_style}}/g, lifestyleData.eyebrow_size
          );
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{eyebrow_style}}/g, '');
        }

        if (lifestyleData.title_size) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(
            /{{title_style}}/g, lifestyleData.title_size
          );
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{title_style}}/g, '');
        }

        if (lifestyleData.description_size) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(
            /{{description_style}}/g, lifestyleData.description_size
          );
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{description_style}}/g, '');
        }

        if (lifestyleData.cta_style === "outline") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{cta_style}}/g, 'btn--inverse');
        } else if (lifestyleData.cta_style === "secondary") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{cta_style}}/g, 'btn--secondary'); 
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{cta_style}}/g, '');
        }

        if (lifestyleData.text_position === "top") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{text_position}}/g, 'flex-start');
        } else if (lifestyleData.text_position === "bottom") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{text_position}}/g, 'flex-end'); 
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{text_position}}/g, 'center');
        }

        if (lifestyleData.text_alignment === "left") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{alignment_items}}/g, 'flex-start');
        } else if (lifestyleData.text_alignment === "right") {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{alignment_items}}/g, 'flex-end');
        } else {  
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{alignment_items}}/g, 'center');
        }

				if (window.matchMedia("(min-width: 1914px)").matches) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{order}}/g, lifestyleData.order || '');
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{page}}/g, lifestyleData.page || '0');
        } else if (window.matchMedia("(min-width: 1468px)").matches) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{order}}/g, lifestyleData.order_medium_screen || '');
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{page}}/g, lifestyleData.page || '0');
        } else if (window.matchMedia("(min-width: 900px)").matches) {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{order}}/g, lifestyleData.order_small_screen || '');
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{page}}/g, lifestyleData.page || '0');
        } else {
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{order}}/g, lifestyleData.order_mobile_screen || '');
          itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{page}}/g, lifestyleData.page || '0');

        }

				if (lifestyleData.video) {
					itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{video}}/g, lifeStyleVideo(lifestyleData.video, lifestyleData.image, lifestyleData.video_player_ui));
					itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{image}}/g, '');
				} else {
					let image_alt_text = lifestyleData.image.alt || lifestyleData.title || lifestyleData.eyebrow || '';

					itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{image}}/g, lifeStyleImage(lifestyleData.image, image_alt_text));
					itemInlineLifestyleblock = itemInlineLifestyleblock.replace(/{{video}}/g, '');
				}
				itemHtml += itemInlineLifestyleblock;
		
				document.body.setAttribute('data-current-inline-block', currentBlockIndex);
			}
		}

    return itemHtml;
  };
  // Build Swatch
  function buildSwatch(data, ob) {
    var _this = ob;
    var itemSwatchHtml = '';
    if (boostPFSConfig.custom.enable_swatches) {
      var swatch_file_extension = 'png';
      var color_count = 0;
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = '';
          itemSwatchHtml += ' <div class="grid-product__colors grid-product__colors--' + data.id + '" >';

          var colorListItems = data.options_with_values.find(o => o.name.toLowerCase().includes("colo"));

          if (colorListItems) {
            colorListItems.values.forEach(function(v) {
				var value = v.title;
                color_count++;
                var colorNameCustom = value.toLowerCase().replaceAll(" / ", "-").replaceAll("/", "-").replaceAll(" ", "-") + "_50x50"
                var color_image = Utils.getFilePath(colorNameCustom, Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
                var color_swatch_fallback = value;
                //var classImageSwatch = variant.image ? 'color-swatch--with-image color-swatch--small' : 'color-swatch--small';
                var attImage = '';

                itemSwatchHtml += '<a  href="' + Utils.buildProductItemUrl(data) + '?variant="' + attImage + ' class="color-swatch" style="background-image: url(' + color_image + '); background-color: ' + color_swatch_fallback + ';">';
                itemSwatchHtml += '</a>';

            });

          }

          itemSwatchHtml += '</div>';
        }
      });
    }
    return itemSwatchHtml;
  }
  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      return paginationHtml;
    }

    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';

    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }

    return html;
  };

  /************************** END BUILD TOOLBAR **************************/

  FilterScrollToTop.prototype.getTemplate = function() {
    return '<a href="javascript:;" aria-label="Back to top" class="boost-pfs-filter-scroll-to-top js-no-transition {{style}}" style="display: inline;">' +
      '<span>Back to top</span>' +
      '</a>';

  }

  // Add additional feature for product list, used commonly in customizing product list
ProductList.prototype.afterRender = function(data, eventType) {
    // Reset lifestyle block index if it's a new page
    const page = Number(Globals.queryParams.page || 1);
    const lastPage = Number(document.body.getAttribute('data-current-inline-block-page') || 0);

    if (page !== lastPage) {
        document.body.setAttribute('data-current-inline-block', 0);
        document.body.setAttribute('data-current-inline-block-page', page);
    }

    AOS.init({
        easing: 'ease-out-quad',
        once: true,
        offset: 60,
        disableMutationObserver: true
    });
    orderItems();
}

  // Build additional elements
  Filter.prototype.afterRender = function(data, eventType) {
    orderItems();

    if (!data) data = this.data;
    var totalProduct = '';
    if (data.total_product == 1) {
      totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              numberQuickViewModalLoaded = 0;
            }
          }});
        });
      }
    }
    theme.initQuickShop();
  };

  function buildBgSet(image) {
    var html = '';
    if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
      var aspectRatio = image.width / image.height;
      if (image.width <= 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
      if (image.width > 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
      if (image.width > 360) html += Utils.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
      if (image.width > 540) html += Utils.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
      if (image.width > 720) html += Utils.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
      if (image.width > 900) html += Utils.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
      if (image.width > 1080) html += Utils.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
      if (image.width > 1296) html += Utils.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
      if (image.width > 1512) html += Utils.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
      if (image.width > 1728) html += Utils.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
    }
    return html;
  }

function orderItems() {
	const items = document.querySelectorAll('.boost-pfs-filter-products .product-card');
	const count = items.length;

	// Assign order to product cards
	items.forEach((item, index) => {
		let customOrder = item.getAttribute('data-order') || (index + 1);
		item.style.order = customOrder;
		item.setAttribute('data-order', customOrder);
	});

	const lifestyleBlocks = document.querySelectorAll('.boost-pfs-filter-products .inline-lifestyle-block');
	const isFirstPage = (Number(Globals.queryParams.page || 1) === 1);

	lifestyleBlocks.forEach((block, index) => {
		const repeatBlock = block.getAttribute('data-repeat-block');

		if (repeatBlock === 'false') {
			// Show only on the first page
			block.style.display = isFirstPage ? 'flex' : 'none';
			return;
		}

		// Repeating blocks: existing logic
		const lifestyleOrders = block.getAttribute('data-order-lifestyle');
		if (lifestyleOrders) {
			const lifestyleOrderArray = lifestyleOrders.split(',').map(v => Number(v.trim()));
			const shouldHide = lifestyleOrderArray.some(order => order > count);
			block.style.display = shouldHide ? 'none' : 'flex';
		} else if (repeatBlock === 'true') {
			const order = (index * 8) + 9;
			block.setAttribute('data-order-lifestyle', order);
			block.style.order = order;
			block.style.display = 'flex';
		}
	});
}

function lifeStyleImage(imageUrl, image_alt_text) {
    let rangeWidths = boostPFSRangeWidths,
        mainImage = '',
        dataSrcSet = '',
        dataWidths = '',
        dataSizes = 'auto';

    for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += imageUrl + 'w_' + rangeWidths[i] + ' ' + rangeWidths[i] + 'w';
        dataWidths += rangeWidths[i];

        if (i < rangeWidths.length - 1) {
            dataSrcSet += ', ';
            dataWidths += ', ';
        }
    }

    mainImage = `<img 
        class="cover"
        src="${imageUrl + "w_" + rangeWidths[2]}"
        srcset="${dataSrcSet}"
        sizes="${dataSizes}" 
        data-widths="[${dataWidths}]"
        alt="${image_alt_text || ''}" 
        loading="lazy" 
    />`;

    return mainImage;
}

	// lifestyle video with custom controls
	function lifeStyleVideo(video, poster) {
    const videoSrc = video;
    const videoPoster = poster.src;

    // create video element without controls, autoplay, muted, playsinline
    const videoHTML = `
        <div class="video-container">
            <video class="video-container__video" 
                   src="${videoSrc}" 
                   type="video/mp4" 
                   poster="${videoPoster}" 
                   autoplay 
                   muted 
                   playsinline 
                   loop 
                   aria-label="video">
                <source src="${videoSrc}" type="video/mp4"/>
            </video>
        </div>
    `;

    return videoHTML;
}

function getCurrentLifestyleBlock() {
    const currentPage = Number(Globals.queryParams.page || 1);
    const currentBlockIndexAttr = document.body.getAttribute('data-current-inline-block') || 0;
    let currentBlockIndex = Number(currentBlockIndexAttr);

    return currentBlockIndex;
}

  /* Expand Filter */
	jQ(document).ready(function() {
		jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
			jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
			jQ('body').toggleClass('boost-pfs-filter-custom-drawer-closed');
			orderItems();
		});
		jQ('.boost-pfs-filter-custom-drawer-close').click(function(){
			jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
			jQ('body').addClass('boost-pfs-filter-custom-drawer-closed');
			orderItems();
		});
		jQ('.boost-pfs-filter-custom-drawer-overlay').click(function(){
			jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
			jQ('body').addClass('boost-pfs-filter-custom-drawer-closed');
		});

		// Bind changing options with enter/space key for ADA
		jQ('.boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay').on('keydown', (event) => {
			if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
			jQ(event.target).click();
			}
		});
	});
  
})();

// Track inline lifestyle block clicks for GTM
document.body.addEventListener('click', function(e) {
    const block = e.target.closest('.inline-lifestyle-block');
    if (!block) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'inlineBlockClick',
        lifestyleId: block.dataset.id,
        lifestylePage: block.dataset.page || 1,
        lifestyleOrder: block.dataset.orderLifestyle || '',
        lifestyleTitle: block.querySelector('.title')?.textContent || ''
    });

    console.log('Inline block clicked:', block.dataset.id); // optional debug
});
